// Screen.tsx — Thin flex-column wrapper for the full app canvas.
// Consumes tokens via useTokens(); accepts children + optional noChrome flag.
//
// P9 (redesign rebuild): hosts the atmosphere washes (spec §3.7). The canvas is
// position:relative + overflow:hidden so the washes sit absolutely behind the
// content; children render in a z-indexed layer above them. Translucent chrome /
// composer (added per-surface) let the washes show through.

import type { JSX, ReactNode } from 'react';
import { useTokens } from '../state/theme';
import { AtmosphereWash } from './AtmosphereWash';

interface ScreenProps {
  children: ReactNode;
  noChrome?: boolean;
}

export function Screen({ children, noChrome: _noChrome }: ScreenProps): JSX.Element {
  const tokens = useTokens();

  return (
    <div
      style={{
        background:   tokens.bg,
        color:        tokens.text,
        fontFamily:   tokens.fonts.body,
        height:       '100%',
        position:     'relative',
        display:      'flex',
        flexDirection:'column',
        overflow:     'hidden',
      }}
    >
      <AtmosphereWash />
      <div
        style={{
          position:     'relative',
          zIndex:       1,
          flex:         1,
          minHeight:    0,
          display:      'flex',
          flexDirection:'column',
        }}
      >
        {children}
      </div>
    </div>
  );
}
